import { render, staticRenderFns } from "./wlwboxdialog.vue?vue&type=template&id=b2f59000&scoped=true&"
import script from "./wlwboxdialog.vue?vue&type=script&lang=js&"
export * from "./wlwboxdialog.vue?vue&type=script&lang=js&"
import style0 from "./wlwboxdialog.vue?vue&type=style&index=0&id=b2f59000&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f59000",
  null
  
)

export default component.exports